import * as React from 'react';
import * as BaseMarkdown from 'react-markdown';

function ExternalLinkRenderer(props: React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>) {
    return (
        <a {...props} target="_blank" />
    );
}

/**
 * Wrapper for Markdown component that opens links in a new tab
 * @param {ReactMarkdown.ReactMarkdownProps} props
 * @return {JSX.Element}
 * @constructor
 */
export default function Markdown(props: BaseMarkdown.ReactMarkdownProps) {
    return (
        <BaseMarkdown renderers={{ link: ExternalLinkRenderer }} {...props} />
    );
}



// WEBPACK FOOTER //
// ./src/Components/Markdown.tsx